import React from "react";

import { Button } from "lib/components/vendor";

import * as FormControl from "lib/components/FormControl";

export default class PaginationNavigation extends React.PureComponent {
  render() {
    const { offset, limit, totalCount, onChange, className, hideDefaultPerPage } = this.props;
    const _options = [
      [10, I18n.t("papp.pagination.show_10")],
      [20, I18n.t("papp.pagination.show_20")],
      [30, I18n.t("papp.pagination.show_30")],
    ];
    const _advnacedOptions = [
      [50, I18n.t("papp.pagination.show_50")],
      [100, I18n.t("papp.pagination.show_100")],
    ];
    const options = st.authorize.member.st_admin ? _options.concat(_advnacedOptions) : _options;
    return (
      <div className={"u-PaginationNavigation " + (className || "")}>
        <span className="u-PaginationNavigation-label">
          {offset + 1}-{Math.min(offset + limit, totalCount)} {I18n.t("papp.components.PaginationNavigation.out_of")}{" "}
          {totalCount}
        </span>
        <Button.Group basic>
          <Button
            as="a"
            icon
            onClick={() => onChange({ offset: Math.max(0, offset - limit), limit })}
            disabled={offset === 0}
          >
            <i className="material-icons icon">chevron_left</i>
          </Button>
          <Button
            as="a"
            icon
            onClick={() => onChange({ offset: offset + limit, limit })}
            disabled={offset + limit > totalCount}
          >
            <i className="material-icons icon">chevron_right</i>
          </Button>
        </Button.Group>
        {!hideDefaultPerPage && (
          <FormControl.Select
            value={limit}
            onChange={(l) => {
              onChange({ offset, limit: l });
              localStorage.setItem(this.props.name, l);
            }}
            options={options}
            className="u-mediumWidth u-marginHorizontal c-inputStandard c-pagingPerTop"
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/PaginationNavigation.jsx